export const organisationAdmin = 'ORGANISATION_ADMIN';

export const standardRolesTypes = {
  ULTIMATE_PARENT_USER: 'ULTIMATE_PARENT_USER',
  ORGANISATION_USER: 'ORGANISATION_USER',
  ANALYST: 'ANALYST',
  PERSONAL_ADVISOR: 'PERSONAL_ADVISOR',
  SERVICE_CENTRE: 'SERVICE_CENTRE',
  DEMO_USER: 'DEMO_USER',
  PORTAL_USER: 'PORTAL_USER',
};

export const allStandardRolesTypes = Object.keys(standardRolesTypes);
